import { createStyles, Header, Group , ThemeIcon, ActionIcon, Container, CopyButton, rem , Text , Avatar , Image , Center , Divider , Title , TypographyStylesProvider , UnstyledButton} from '@mantine/core';
import { IconBrandTwitter, IconMapPin , IconPhone , IconBrandInstagram , IconBrandLinkedin , IconBrandYoutube , IconBrandItch } from '@tabler/icons-react';
import { FooterSimple } from '../Components/Footer';
import {useNavigate} from 'react-router-dom'
import {useEffect} from 'react'

const useStyles = createStyles((theme) => ({
    inner: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: rem(56),
  
      [theme.fn.smallerThan('sm')]: {
        justifyContent: 'flex-start',
      },
    },
  
    links: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
  
    social: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        width: 'auto',
        marginLeft: 'auto',
      },
    },
  }));
  
  const listData = {
    "footerLink": [
      {
        "link": "#",
        "label": "Copyright @ 2023"
      },
      {
        "link": "/privacy_policy",
        "label": "Privacy Policy"
      },
      {
        "link": "/terms_and_conditions",
        "label": "Terms and Condition"
      }
    ]
  }

function ARGPage() {
    const navigate = useNavigate();
    const { classes, cx } = useStyles();
    useEffect(() => {
      document.getElementById('header')?.scrollIntoView({behavior : 'auto'})
    }, [])
    return (
        <div>
            <Header height={56} mb={20} id='header'>
                <Container className={classes.inner}>
                <Group className={classes.links} spacing={5}>
                </Group>
        
                <Text
                    variant="gradient"
                    gradient={{ from: 'indigo', to: 'cyan', deg: 45 }}
                    sx={{ fontFamily: 'Greycliff CF, sans-serif' }}
                    ta="center"
                    fz="3.5vw"
                    fw={700}
                    onClick={()=>{navigate('/')}}
                    >
                Freak-Bros
                </Text>
        
                <Group spacing={0} className={classes.social} position="right" noWrap>
                <ActionIcon size="lg">
                    <IconBrandTwitter size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandYoutube size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandInstagram size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandItch size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandLinkedin size="1.1rem" stroke={1.5} />
                </ActionIcon>
                </Group>
                </Container>
            </Header>
            <Container>
                <Center maw={400} h={200} mx="auto">
                <Image width={200} height={200} radius='xl' src="https://firebasestorage.googleapis.com/v0/b/freak-bros.appspot.com/o/chippi.jpg?alt=media&token=c6ada32a-3857-4b7c-9b9c-9d23916af7b4" alt="Ayush's pic" withPlaceholder />
                </Center>
                <Title color='dimmed' style={{paddingTop:10}}>
                    Ayush Raj Gupta
                </Title>
                <Container size='sm'>
                <Divider my="sm" size='md' variant="dashed" />
                </Container>
                <TypographyStylesProvider>
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Highly skilled 3D Artist and Game Developer with 3 years of professional experience and a proven track record of completing 15 games, including hypercasual, casual, story-driven, and prototype games. Proficient in game development tool Unity , as well as 3D modeling software Blender. Strong artistic skills, creative vision, and ability to bring ideas to life through visually stunning and engaging games.</p>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Designed, developed, and published 15 games across various genres, including hypercasual, casual, story-driven, and prototype games, using Unity and Unreal Engine.</p>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Created 3D models, textures, animations, and visual effects to enhance the visual quality and user experience of games.</p>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Conducted playtesting and gathered feedback to make iterative improvements to gameplay, user interface, and overall game experience.</p>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>3D Artist</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Produced high-quality 3D models, textures, animations, and visual effects for various game projects, using industry-standard software such as Blender, Z brush and Substance Painter.</li><li>Collaborated with game designers and programmers to create visually appealing and engaging game environments, characters, and props.</li><li>Conducted research and kept up-to-date with the latest industry trends, techniques, and technologies to continuously improve artistic skills and deliver cutting-edge game art.</li></ul>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Skills</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Strong proficiency in Unity for game development.</li><li>Proficient in 3D modeling software such as Blender and Substance painter.</li><li>Solid understanding of game design principles, including gameplay mechanics, user experience, and player engagement.</li><li>Artistic skills, including 3D modeling, texturing, animation, and visual effects.</li><li>Ability to work collaboratively in a team-oriented environment.</li><li>Passion for creating visually stunning and immersive games that deliver an exceptional player experience.</li></ul>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                     <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Contact Info</H2>'
                    }} />
                    <UnstyledButton style={{paddingTop:10}}>
                    <Group>
                        <Avatar size={40} color="blue">ARG</Avatar>
                        <div>
                        <Text>Ayush Raj Gupta</Text>
                        <Text size="xs" color="dimmed">ayushrajgupta09@gmail.com</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                    <br/>
                    <UnstyledButton style={{paddingTop:20}}>
                    <Group>
                        <ThemeIcon variant="light" radius="md" size="xl">
                            <IconPhone />
                        </ThemeIcon>
                        <div>
                        <Text>Phone No.</Text>
                        <Text size="xs" color="dimmed">+91-6206043986</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                    <br/>
                    <UnstyledButton style={{paddingTop:20}}>
                    <Group>
                        <ThemeIcon variant="light" radius="md" size="xl">
                            <IconMapPin />
                        </ThemeIcon>
                        <div>
                        <Text>Address.</Text>
                        <Text size="xs" color="dimmed">Nai Bazar , Muzaffarpur , Bihar , India</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                </TypographyStylesProvider>
              </Container>
              <FooterSimple links={listData.footerLink}/>
        </div>
  );
}

export default ARGPage;
